import { render, staticRenderFns } from "./guifan.vue?vue&type=template&id=45247664&scoped=true&"
import script from "./guifan.vue?vue&type=script&lang=js&"
export * from "./guifan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45247664",
  null
  
)

export default component.exports